/* eslint-disable no-unused-vars */
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { IPragmaticLiveDTO, IPragmaticGetUrl } from '../../types/interfaces/LiveCasino/PragmaticLiveDTO';
import { allowlistedBlackJackPragmatic, getCategories } from '../../utils/liveCasinoSort';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { CasinoType } from 'modules/Casino/types/configuration';
class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IPragmaticLiveDTO[]>): ISlotViewItem[] =>
    data
      .filter(el => el.gameTypeID === 'lg') // получаем только лайв игры
      .filter(t => {
        const isBlackjack = t.gameName.toLowerCase().includes('blackjack');
        const isAllowlisted = allowlistedBlackJackPragmatic.includes(t.gameID);
        return !isBlackjack || isAllowlisted;
      })
      .map((item: IPragmaticLiveDTO) => ({
        id: item.gameID,
        gameId: item.gameID,
        routeProvider: 'pragmaticlive',
        gameName: item.gameName,
        type: CasinoType.liveCasino,
        provider: 'pragmatic',
        description: item.gameName,
        imageUrl: `https://bsw-dk1.pragmaticplay.net/game_pic/square/200/${item.gameID}.png`,
        technologyId: item.technologyID,
        tab: getCategories(item.gameName, item.gameID, 'pragmatic'),
      }));

  convertGameUrl = ({ data }: IPragmaticGetUrl) => data.url;
}

export default Converter;
